function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M193.8 99.1v-14c0-15.8-12.8-28.6-28.7-28.7h-46.8c-15.8 0-28.6 12.8-28.7 28.7v14H7.1v184.4h269.3V99.1h-82.6zm-9.5 28.5V255H99.4V127.6h84.9zm-66.1-42.5c0-.1.1-.2.2-.2h46.8c.1 0 .2.1.2.2v14h-47.1v-14zm-82.6 42.5h35.3V255H35.6V127.6zM247.9 255h-35.1V127.6h35.1V255z"
})));